import gql from 'graphql-tag'

export const TEST_QUERY_SCHEDULER = gql`
  mutation test_query_scheduler($input: elastic_query) {
    test_query_scheduler(input: $input)
      @rest(type: "Scheduler", path: "/test-query-scheduler", bodyKey: "input", method: "POST") {
      status
      message
    }
  }
`
